import { useTranslation } from 'react-i18next'
import { Link } from '@structural-climbing/ui'
import { publicSiteUrl } from '../competitions/publicSite'

/**
 * Structural's own privacy policy, on the public site.
 *
 * Not the gym's notice. A gym links its own from the signing screen, for the
 * data it decides about. This one is ours, for the account a member holds with
 * us across every gym, and the app showed it nowhere: someone could sign up and
 * use the app for months without ever being pointed at it.
 */
export function PrivacyPolicyLink({ className = '' }: { className?: string }) {
  const { t } = useTranslation()
  return (
    <Link
      href={publicSiteUrl('/privacy')}
      isExternal
      underline="always"
      className={`text-tiny text-foreground/45 ${className}`}
    >
      {t('common.privacyPolicy')}
    </Link>
  )
}
